module.exports = __webpack_public_path__ + "static/JAM Stack-193065fe56763ecd3eb7b0fe9c76d872.jpg";